// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRequisitesDto
 */
export interface IRequisitesDto {
    /**
     * 
     * @type {string}
     * @memberof IRequisitesDto
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IRequisitesDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof IRequisitesDto
     */
    card_holder_name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IRequisitesDto
     */
    card_expiration_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IRequisitesDto
     */
    card_last4?: string;
    /**
     * 
     * @type {string}
     * @memberof IRequisitesDto
     */
    card_token?: string;
    /**
     * 
     * @type {string}
     * @memberof IRequisitesDto
     */
    card_type?: IRequisitesDtoCardTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IRequisitesDto
     */
    account_number_length?: number;
    /**
     * 
     * @type {string}
     * @memberof IRequisitesDto
     */
    account_description?: string;
    /**
     * 
     * @type {string}
     * @memberof IRequisitesDto
     */
    account_number_last4?: string;
}

/**
* @export
* @enum {string}
*/
export enum IRequisitesDtoCardTypeEnum {
    AMEX = 'AMEX',
    VISA = 'VISA',
    MASTERCARD = 'MASTERCARD'
}


/**
 * Check if a given object implements the IRequisitesDto interface.
 */
export function instanceOfIRequisitesDto(value: object): value is IRequisitesDto {
    return true;
}

export function IRequisitesDtoFromJSON(json: any): IRequisitesDto {
    return IRequisitesDtoFromJSONTyped(json, false);
}

export function IRequisitesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRequisitesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'phone_number': json['phone_number'] == null ? undefined : json['phone_number'],
        'email': json['email'] == null ? undefined : json['email'],
        'card_holder_name': json['card_holder_name'] == null ? undefined : json['card_holder_name'],
        'card_expiration_date': json['card_expiration_date'] == null ? undefined : (new Date(json['card_expiration_date'])),
        'card_last4': json['card_last4'] == null ? undefined : json['card_last4'],
        'card_token': json['card_token'] == null ? undefined : json['card_token'],
        'card_type': json['card_type'] == null ? undefined : json['card_type'],
        'account_number_length': json['account_number_length'] == null ? undefined : json['account_number_length'],
        'account_description': json['account_description'] == null ? undefined : json['account_description'],
        'account_number_last4': json['account_number_last4'] == null ? undefined : json['account_number_last4'],
    };
}

export function IRequisitesDtoToJSON(json: any): IRequisitesDto {
    return IRequisitesDtoToJSONTyped(json, false);
}

export function IRequisitesDtoToJSONTyped(value?: IRequisitesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phone_number': value['phone_number'],
        'email': value['email'],
        'card_holder_name': value['card_holder_name'],
        'card_expiration_date': value['card_expiration_date'] == null ? undefined : ((value['card_expiration_date']).toISOString().substring(0,10)),
        'card_last4': value['card_last4'],
        'card_token': value['card_token'],
        'card_type': value['card_type'],
        'account_number_length': value['account_number_length'],
        'account_description': value['account_description'],
        'account_number_last4': value['account_number_last4'],
    };
}

